export default "__VITE_ASSET__BZtl4PvF__"